const NotFound = () => {
    const language = window.location.pathname.includes('/en/') ? 'en' : 'ar';
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        {language === 'en' ? (
          <>
            <h1>Page Not Found</h1>
            <p>The page you're looking for doesn't exist.</p>
            <a href="/en/" style={{ color: "#007bff", textDecoration: "underline" }}>
              Go Home
            </a>
          </>
        ) : (
          <>
            <h1>الصفحة غير موجودة</h1>
            <p>الصفحة التي تبحث عنها غير موجودة.</p>
            <a href="/" style={{ color: "#007bff", textDecoration: "underline" }}>
              العودة إلى الصفحة الرئيسية
            </a>
          </>
        )}
      </div>
    );
  };
export default NotFound;